import React from 'react';
import MenuCompetitionItemLive from './../MenuCompetitionItemLive';

function PreferitiSportItem(props) {
    const competitionsList = props.competitions.map(function(competition) {
        return <MenuCompetitionItemLive key={competition.id} {...competition} />
    });

    return (
        <div className="regione-widget">
            <div className="elemento-competizioni-widget pointer toggle-nascondi-live tog-menu" data-toggle="collapse" data-target={'#in-evidenza-menu-' + props.id}>
                <span>{props.descrizione}</span><span>{props.competitions.length}</span>
            </div>
            <div className="competizione-sub collapse show" id={'in-evidenza-menu-' + props.id}>
                {competitionsList}
            </div>
        </div>
    );
}
    
export default PreferitiSportItem;